import { Box, Button, Typography } from '@mui/material';
import { RSB_URL } from 'helpers';

export default function RsbCta() {
    return (
        <a
            aria-label="Read The Real Startup Book"
            data-testid="rsb-cta-link"
            href={RSB_URL}
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
            target="_blank"
        >
            <Box
                alignItems="center"
                border="1px solid #E5DED0"
                borderRadius={3}
                display="flex"
                flexDirection="column"
                gap={1.5}
                padding={3}
                sx={{ backgroundColor: '#F7F4EF' }}
            >
                <Typography color="#1F1F1F" textAlign="center" variant="montserrat524">
                    Understand the model?
                </Typography>
                <Typography color="#4E4E4E" textAlign="center" variant="montserrat518">
                    Read The Real Startup Book — the framework behind this tool.
                </Typography>
                <Box>
                    <Button component="span">Read The Real Startup Book</Button>
                </Box>
            </Box>
        </a>
    );
}
